import Submenu from './Submenu';


Submenu.install = function(Vue) {
  Vue.component(Submenu.name, Submenu);
};

export default Submenu;
